<template>
  <div class="wrapper">
    <!-- <div class="title">创建试卷四部曲</div> -->
    <el-steps
      :active="step + 1"
      align-center
      style="background: #fff; padding: 15px 0"
      v-if="!$route.query.id"
    >
      <el-step title="基本信息"></el-step>
      <el-step title="选择试题"></el-step>
      <el-step title="试卷设置"></el-step>
      <el-step title="完成"></el-step>
    </el-steps>

    <Tabs type="card" class="stepInput" :animated="false" v-if="step == 0">
      <TabPane label="试卷必要信息" class="paneBox">
        <!-- <div class="paneBox"> -->
        <div class="inputBar">
          试卷标题
          <br />
          <Input
            v-model="examData.exName"
            placeholder="试卷标题最多可填写40个字符(汉字占两个字符)"
          />
        </div>
        <div class="inputBar">
          试卷类别
          <br />
          <treeinput
            :questionTypeTree="examinationTypeList"
            @treeEvent="treeEvent"
            :currentNodeId="examData.exGroupId"
          ></treeinput>
        </div>
      </TabPane>
      <TabPane label="试卷描述" class="paneBox">
        <el-upload
          class="avatar-uploader"
          :show-file-list="false"
          :http-request="ossUpload"
          :on-success="uploadSuccess"
          :headers="{ Authorization: getStore('accessToken') }"
          action
        >
          <img
            v-if="examData.imageUrl"
            :src="examData.imageUrl"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>

        <!-- <img src="https://fs.youkaoshi.cn/papercover/others/others_1.png" alt /> -->
        <div class="inputBar">
          关键字
          <br />
          <Input v-model="examData.keyWord" placeholder="逗号分隔的关键字" />
        </div>
        <div class="inputBar">
          描述(试卷描述内容，会在分享到微信或QQ时给考生看到)
          <br />
          <Input
            v-model="examData.description"
            type="textarea"
            :autosize="true"
            placeholder="你不点进来，怎么知道你很厉害"
          />
        </div>
      </TabPane>
    </Tabs>

    <div class="stepInput" v-if="step == 1">
      <h3 class="title">添加试题到试卷：《{{ examData.exName }}》</h3>
      <examination-question-edit
        ref="questionEdit"
        @formThePaper="formPaper"
        @nextStep="nextStep"
        :examData="examData"
      ></examination-question-edit>
    </div>
    <!-- 试卷设置 -->
    <exam-setting
      v-if="step == 2"
      ref="examSetting"
      :examId="examData.id"
      @postSetting="postSetting"
    ></exam-setting>
    <div class="successPage" v-if="step == 3">
      <h1 style="margin: 20px auto">新测试</h1>
      <div class="tipsBox">
        <div class="percentageBox">
          <el-progress
            type="circle"
            :show-text="false"
            :percentage="percentage"
            :width="160"
          >
          </el-progress>
          <div class="baseBox">
            <div class="frontCircle" ref="frontCircle"></div>
            <div class="circleStatus"></div>
          </div>
        </div>

        <h2 style="margin-top: 20px">试卷创建成功</h2>
        <h3>试卷当前处于草稿状态，发布后考生方可考试</h3>
        <h4 class="greyFont" style="margin: 20px 0">试卷开放时间：至</h4>
        <!-- <el-button type="primary" plain>发布</el-button> -->
        <!-- <el-button type="primary">预览</el-button> -->
        <el-button type="primary" @click="goTo('examination-list')"
          >返回试卷列表</el-button
        >
      </div>
    </div>
    <div class="actBar">
      <el-button type="primary" v-if="step != 3" @click="nextStep()"
        >保存{{ $route.query.id ? "" : "并进入下一步" }}</el-button
      >
      <el-button type="primary" @click="ifPreview = true">预览</el-button>
    </div>
    <el-dialog
      title="试卷预览"
      :visible.sync="ifPreview"
      width="60%"
      :modal-append-to-body="false"
      :destroy-on-close="true"
    >
      <!-- <div class="toBlack" style="position: fixed; left: 0; top: 0; z-index: 68"> -->
      <iframe
        :src="shareExamUrl"
        :width="screenWidth * 0.58"
        :height="screenHeight * 0.7 - 65"
        frameborder="0"
      ></iframe>
      <!-- </div> -->
    </el-dialog>
  </div>
</template>

<script>
import Editor from "wangeditor";
import treeinput from "@/component/tree/treeInput.vue";
import mytree from "@/component/tree/mytree.vue";
import examinationQuestionEdit from "@/views/examination-management/component/examinationQuestionEdit.vue";
import examSetting from "@/views/examination-management/component/examSetting.vue";
import { Base64 } from "@/libs/js/base64.js";
import {
  getExaminationType,
  renameExaminationType,
  deleteExaminationType,
  appendExaminationType,
  moveExaminationType,
  createExamination,
  formThePaper,
  postPaperSetting,
  getPaperData,
  editPaper,
} from "@/api/examination/examination.js";
export default {
  components: { mytree, examSetting, treeinput, examinationQuestionEdit },
  props: {},
  data() {
    return {
      screenWidth: document.documentElement.clientWidth,
      screenHeight: document.documentElement.clientHeight,
      ifPreview: false,
      step: 0,
      title: "",
      showType: false,
      treeData: [],
      examData: {
        exName: "",
        exGroupId: 0,
        description: "",
        imageUrl: "",
        id: 0,
        keyWord: "",
      },
      examGroup: "",
      dialogData: { title: "标题", ifShow: false },
      examinationTypeList: [],
      temporaryTree: "",
      examinationType: {},
      percentage: 0,
      Base64: new Base64(),
    };
  },
  watch: {},
  computed: {
    shareExamUrl() {
      let query = this.Base64.encode(`examId-${this.examData.id}`);
      let host = "testxk.cbstudy.com/exam";
      // document.location.host.indexOf("cbtest") > -1
      //   ? "cbtest.cbstudy.cn"
      //   : "exam.cbstudy.com";
      return `https://${host}/#/?${query}`;

      // return `https:///#/?${query}`;
    },
  },
  methods: {
    pageInit() {
      let that = this;
      getExaminationType().then((data) => {
        data.groupNodeList.forEach(function treeMaker(item) {
          item.expand = false;
          item.contextmenu = true;
          if (that.$route.query.id && item.id == that.examData.exGroupId) {
            that.examinationType = item;
          }
          if (item.children && item.children.length > 0) {
            item.children.forEach((nextItem) => treeMaker(nextItem));
          }
        });

        this.examinationTypeList = data.groupNodeList;
      });
    },
    postSetting(data) {
      // console.log(data);
      data.examId = this.examData.id;
      postPaperSetting(data).then((data) => {
        if (this.$route.query.id) {
          this.$message.success("修改成功");
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        } else {
          this.step++;
          setTimeout(() => {
            this.percentage = 100;
            setTimeout(() => {
              this.$refs.frontCircle.style.WebkitTransform = "scale(0)";
            }, 200);
          }, 100);
        }
      });
    },
    treeEvent(eventDetail, data) {
      switch (eventDetail.type) {
        case "rename":
          renameExaminationType({
            id: eventDetail.contextData.id,
            parentId: eventDetail.contextData.parentId,
            newName: eventDetail.value,
          }).then(
            (data) => {
              this.$Message.success("修改成功");
              this.examinationTypeInit();
            },
            (data) => {
              this.$Message.error(data || "错误");
            }
          );

          break;
        case "delete":
          deleteExaminationType({
            id: eventDetail.value,
          }).then(
            (data) => {
              this.$Message.success("删除成功");
              this.examinationTypeInit();
            },
            (data) => {
              this.$Message.error(data || "错误");
            }
          );
          break;
        case "append":
          appendExaminationType({
            parentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
            (data) => {
              this.$Message.success("创建成功");
              this.examinationTypeInit();
            },
            (data) => {
              this.$Message.success(data || "创建失败");
            }
          );
          break;
        case "move":
          moveExaminationType({
            id: eventDetail.id,
            newParentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
            (data) => {
              this.$Message.success("移动成功");
              this.examinationTypeInit();
            },
            (data) => {
              this.$Message.success(data || "移动失败");
            }
          );
          break;
        // case "chosen":
        //   console.log(eventDetail);
        //   this.settingData.studentGroupChosen = eventDetail.value;
        //   break;
        case "select":
          this.temporaryTree = eventDetail.value;
          break;
        case "confirm":
          this.examinationType = this.temporaryTree;
          this.examData.exGroupId = this.temporaryTree.id;
          break;
        default:
          break;
      }
    },
    nextStep() {
      switch (this.step) {
        case 0:
          this.examData.name = this.examData.exName;
          if (this.$route.query.id) {
            this.examData.examId = this.examData.id;

            editPaper(this.examData).then(
              (data) => {
                this.$message.success("编辑成功");
                this.$router.go(-1);
              },
              (err) => {
                this.$message.error("编辑失败，请检查输入项");
              }
            );
          } else {
            createExamination(this.examData).then(
              (data) => {
                this.examData.id = data;
                this.examData.examId = data;
                this.step++;
              },
              (data) => {
                this.$message.error(data);
              }
            );
          }

          break;
        case 1:
          this.$refs.questionEdit.formPaper();
          break;
        case 2:
          this.$refs.examSetting.showData();
          break;
        default:
          break;
      }
    },
    formPaper(postData) {
      Object.assign(postData, this.examData);
      formThePaper(postData).then((data) => {
        if (this.$route.query.id) {
          this.$message.success("组卷成功");
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        } else {
          this.step++;
        }
        // this.nextStep();
      });
    },
    closeDialog() {
      this.dialogData.ifShow = false;
    },

    groupConfirm() {
      this.settingData.studentGroupChosen =
        this.$refs.groupTree.getCheckedNodes();
      this.dialogData.ifShow = false;
    },
    ossUpload(data) {
      console.log(data.file);
      return this.$oss.put(
        data.file.uid + "." + data.file.type.split("/")[1],
        data.file
      );
    },
    goTo(pathName) {
      this.$router.push({ name: pathName });
    },
    uploadSuccess(data) {
      this.examData.imageUrl = data.url;
    },
  },
  created() {},
  mounted() {
    let query = this.$route.query;

    if (query.id) {
      this.examData.examId = query.id;
      getPaperData({ id: query.id }).then((data) => {
        data.examId = data.id;
        data.name = data.exName;
        this.$set(this.$data, "examData", data);
        this.pageInit();
      });
      this.step = query.ifEdit - 1;
    } else {
      this.pageInit();
    }
  },
};
const editorMenus = [
  //   "head", // 标题
  "bold", // 粗体
  "fontSize", // 字号
  "fontName", // 字体
  "italic", // 斜体
  "underline", // 下划线
  "strikeThrough", // 删除线
  "foreColor", // 文字颜色
  "backColor", // 背景颜色
  //   "link", // 插入链接
  "list", // 列表
  "justify", // 对齐方式
  "quote", // 引用
  "image", // 插入图片
  "table", // 表格
  "video", // 插入视频
  "code", // 插入代码
  "undo", // 撤销
  "redo", // 重复
];
</script>
<style lang="less">
/deep/ .single-page-con {
  z-index: 22 !important;
}
</style>
<style lang="less" scoped>
.greyFont {
  color: #ccc;
}
.wrapper {
  .actBar {
    display: flex;
    justify-content: center;
    .el-button {
      min-width: 120px;
    }
  }
  .stepInput {
    padding-bottom: 10px;
    .title {
      margin: 15px 0 10px 0;
    }
    .settingContent {
      padding: 30px;
      .inputBar {
        font-size: 1.2em;
        padding: 10px 30px;
        .title {
          font-size: 1.2em;
          position: relative;
          margin: 10px 0;
        }
        .title::after {
          content: "";
          width: 4px;
          height: 100%;
          background: #36aafd;
          position: absolute;
          top: 0;
          left: -10px;
        }
        .chooseContainer {
          .showBar {
            padding: 10px;
            border: 1px solid #36aafd;
            border-radius: 5px;
            width: 80%;
            .el-button--small,
            .el-tag {
              margin-right: 10px;
            }
            min-height: 50px;
          }
        }
        .defaultDescriptBox {
          margin: 20px 0;
          width: 40%;
          min-width: 400px;
          border-radius: 4px;
          border: solid 1px #36aafd;
          padding: 15px 40px 15px 40px;
          .spaceBwteen {
            display: flex;
            justify-content: space-between;
            font-size: 1.2em;
          }
        }

        /deep/ .el-checkbox {
          margin: 8px 30px 8px 0;
          /deep/ .el-checkbox__label {
            font-size: 1.2em;
          }
        }
        .inputSecBar {
          margin-left: 24px;
          line-height: 32px;
          .el-input {
            margin: 0 8px;
            width: 60px;
          }
          .el-select {
            width: 70px;
          }
        }
        .imgChooseBox {
          padding: 10px 20px;
          border: 1px solid #ccc;
          color: #ccc;
          border-radius: 5px;
          text-align: center;
          display: inline-block;
          margin: 10px;
          i {
            font-size: 30px;
          }
        }
        .imgChosenBox {
          padding: 10px 20px;
          margin: 10px;
          border: 1px solid #618afd;
          color: #618afd;
          border-radius: 5px;
          text-align: center;
          display: inline-block;
          i {
            font-size: 30px;
          }
        }
        .greyTips {
          background-color: #f5f5f5;
          font-size: 14px;
          color: #666666;
          width: 82%;
          padding: 20px;
        }
      }
    }
    .paneBox {
      border: 1px solid #ccc;
      border-top: none;
      padding: 10px;
    }
    .examinationPane {
      min-height: 400px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .el-radio {
      margin: 10px 0;
      .el-input {
        width: 80px;
      }
    }
    /deep/ .ivu-tabs-bar {
      margin-bottom: 0;
    }
    /deep/ .el-submenu .el-menu-item {
      padding: 0 !important;
      text-align: center;
      min-width: 0;
      width: 100%;
      overflow: hidden;
    }
    /deep/ .is-opened {
      .el-submenu__title {
        background: #ccc;
        color: #fff;
      }
    }
  }
  .editorContainer {
    margin: 20px 0;
    width: 660px;
    /deep/ .w-e-toolbar {
      flex-wrap: wrap;
    }
    .keywordBar {
      .keyword {
        position: relative;
        display: inline-block;
        line-height: 24px;
        height: 24px;
        padding: 0 8px;
        border-radius: 12px;
        overflow: hidden;
        border: 1px solid #ccc;
        font-size: 1rem;
        margin: 15px 3px;
        .keywordHover {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  .successPage {
    margin: auto;
    text-align: center;

    .tipsBox {
      width: 600px;
      padding: 80px 30px;
      margin: auto;

      color: #409eff;
      background: #fff;
    }
    .percentageBox {
      width: 160px;
      position: relative;
      margin: auto;
      .baseBox {
        position: absolute;
        left: 5px;
        top: 5px;
        height: 150px;
        width: 150px;
        border-radius: 50%;
        //  rgb(19, 206, 102);
        background: #20a0ff;
        .frontCircle {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: #fff;
          transition: all 0.3s ease-in 0.3s;
        }
      }
      .circleStatus {
        width: 56%;
        height: 22%;
        border-bottom: 8px solid rgb(255, 255, 255);
        border-left: 8px solid rgb(255, 255, 255);
        box-sizing: border-box;
        position: absolute;
        left: 22%;
        top: 38%;
        transform: rotate(-45deg);
      }
    }
  }
}
/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 400px;
  height: 300px;
  line-height: 300px;
  text-align: center;
}
/deep/ .avatar {
  width: 400px;
  height: 300px;
  display: block;
  object-fit: contain;
}
</style>